module.exports = __webpack_public_path__ + "static/img/stimulusGamesGray.d08cf4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stimulusGamesGray.png
// module id = +7Cb
// module chunks = 1